import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  addMoneyToUserWallet,
  disableEnableUser,
  getUserDetails,
} from "../../../features/Users";
import {
  Header,
  ProfileImage,
  UserInfo,
  Wrapper,
  Container,
  Action,
  ActionStaus,
  ActionWallet,
  ModalWrapper,
  ModalMessege,
  UserBalance,
  ModalFrom,
  InputSection,
  SectionWrapper,
  Active,
  ActionDetail,
  ActionWrapper,
  ProfileImageWrapper,
  
} from "./StyledUserDetails";
// import { Container } from '@mui/material';
import { RootState } from "../../../app/Store";
import { transformDOB } from "../../../Utility/Utility";
import Button from "../../../components/UI/Button/Button";
import ActionModal from "../../../components/Modal/ActionModal";
import Modal from "../../../components/Modal/Modal";
import { TextField } from "@mui/material";
import ViewHeader from "../../../components/ViewHeader/ViewHeader";
import { adminRouts } from "../../../routs";
import userProfileImg from "../../../assets/images/profile.jpg";
import UserSkeleton from "./UserSkeleton";
import { userProfilePicture } from "../../../networkUtility/endpoints";
enum ButtonSize {
  sm = "small",
  md = "medium",
  lg = "large",
}
enum ButtonVariant {
  primaryFilled = "primary-filled",
  secondary = "secondary",
  primaryLink = "primaryLink",
  danger = "danger",
  dangerOutline = "dangerOutline",
}
const Userdetails = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const [openEditModel, setOpenEditModel] = useState(false);
  const [openDisableModel, setOpenDisableModel] = useState(false);
  const [amount, setAmount] = useState("");
  const [valid, setValid] = useState(false);

  // console.log(params.publicUserId)
  const userDetails = useSelector((state: RootState) => state.users.useDetail);
  const isLoading = useSelector(
    (state: RootState) => state.loaderslice.isLoading
  );
  console.log(userDetails);

  useEffect(() => {
    dispatch(getUserDetails(params?.publicUserId));
  }, []);

  const disableEnableUserModalHandler = () => {
    setOpenDisableModel(true);
  };
  const disableEnableUserHandler = () => {
    // console.log(userId)
    dispatch(
      disableEnableUser({
        userId: userDetails?.userId,
        publicUserId: params.publicUserId,
      })
    );
    setOpenDisableModel(false);
  };
  const editUserHandler = () => {
    setOpenEditModel(true);
  };
  const handleInputChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ): void => {
    setAmount(event.target.value);
    setValid(false);
  };
  const editUserModalHandler = (
    event: React.ChangeEvent<HTMLFormElement>
  ): void => {
    event.preventDefault();
    if (!amount.trim()) {
      setValid(true);
      return;
    }
    // alert(amount);
    dispatch(
      addMoneyToUserWallet({
        publicUserId: userDetails?.publicUserId,
        amount: Number(amount),
        userId: userDetails?.userId,
      })
    );
    setOpenEditModel(false);
    setAmount("");
  };

  const detailsView = (
    <>
      <UserInfo>
        <ActionWrapper>
          <ProfileImageWrapper>
            {userDetails?.imageUrl !== null? (
              <ProfileImage
                key={userDetails?.imageUrl}
                src={`${userProfilePicture}${
                  userDetails?.imageUrl
                }`}
                alt={
                  userDetails?.imageUrl === null
                    ? "user image not avilable"
                    : "User's Profile Picture"
                }
              />
            ) : (
              <ProfileImage
                src={userProfileImg}
                alt={
                  userDetails?.imageUrl === null
                    ? "user image not avilable"
                    : "User's Profile Picture"
                }
              />
            )}
          </ProfileImageWrapper>
          <Action>
            <ActionStaus>
              <ActionDetail>
                <strong>Status:</strong>
                <Active active={userDetails?.isActive}>
                  {userDetails?.isActive ? "Active" : "Inactive"}
                </Active>
              </ActionDetail>
              <Button
                title={userDetails?.isActive ? "Deactivate" : "Activate"}
                btnSize={ButtonSize.sm}
                btnVariant={
                  userDetails?.isActive
                    ? ButtonVariant.dangerOutline
                    : ButtonVariant.secondary
                }
                // clicked={() => disableEnableUserHandler(tableRowObj.userId)}
                clicked={disableEnableUserModalHandler}
              />
            </ActionStaus>
            <ActionWallet>
              <ActionDetail>
                <strong>Wallet Balance :</strong>${userDetails?.amount}
              </ActionDetail>
              <Button
                title={" Add Money "}
                btnSize={ButtonSize.sm}
                btnVariant={ButtonVariant.danger}
                clicked={editUserHandler}
              />
            </ActionWallet>
          </Action>
        </ActionWrapper>

        <div>
          <h2>
            {userDetails?.firstName} {userDetails?.lastName}
          </h2>
          <p>
            <strong>User ID :</strong>
            {userDetails?.userId}
          </p>
          {/* <p>
                <strong>Date of Birth :</strong>
                {userDetails?.dateOfBirth!==null? transformDOB(userDetails?.dateOfBirth):""}
              </p> */}
          {/* <p>
                <strong>Gender :</strong>
                {userDetails?.gender}
              </p> */}
          <p>
            <strong>Email :</strong>
            {userDetails?.emailId}
          </p>
          <p>
            <strong>Mobile Number :</strong>
            {userDetails?.mobileNo}
          </p>
          <p>
            <strong>Address :</strong>
            {userDetails?.address}
          </p>
          <p>
            <strong>City :</strong>
            {userDetails?.city}
          </p>
          <p>
            <strong>State :</strong>
            {userDetails?.state}
          </p>
          <p>
            <strong>Country :</strong>
            {userDetails?.country}
          </p>
          <p>
            <strong>Zip Code :</strong>
            {userDetails?.pinCode}
          </p>
          {/* <p>
                <strong>Role Name :</strong>
                {userDetails?.roleName}
              </p> */}
          <p>
            <strong>Gold Member :</strong>
            {userDetails?.isGoldMember ? "Yes" : "No"}
          </p>
          <p>
            <strong>Using 2FA (Two-Factor Authentication) :</strong>
            {userDetails?.using2FA ? "Yes" : "No"}
          </p>
        </div>
      </UserInfo>
    </>
  );

  return (
    <Wrapper>
      <ViewHeader
        title={"User Details"}
        isBackButtonRequired={true}
        backButtonRedirectionUrl={adminRouts.usersList}
      />
      <SectionWrapper>
        <ActionModal
          confirm={disableEnableUserHandler}
          openModal={openDisableModel}
          title={userDetails?.isActive ? "Deactivate" : "Activate"}
          setOpenModal={setOpenDisableModel}
          content={"User"}
        />
        <Modal
          isOpen={openEditModel}
          name={"Add Money Model"}
          title={"Add Money to User wallet."}
          toggleModal={() => setOpenEditModel(false)}
        >
          <ModalWrapper>
            <ModalMessege>You can only update user wallet amount.</ModalMessege>
            <UserBalance>
              User Wallet Balance : ${userDetails?.amount}
            </UserBalance>
            <ModalFrom>
              <form onSubmit={editUserModalHandler}>
                <InputSection>
                  <TextField
                    fullWidth={true}
                    id="outlined-basic"
                    label="add amount"
                    variant="outlined"
                    value={amount}
                    onChange={(e) => handleInputChange(e)}
                    // required={true}
                    error={valid}
                    helperText={valid && "Please enter amount."}
                  />
                  <div>
                    <Button
                      title={"Update"}
                      btnSize={ButtonSize.md}
                      btnVariant={ButtonVariant.danger}
                      clicked={() => {}}
                    />
                  </div>
                </InputSection>
              </form>
            </ModalFrom>
          </ModalWrapper>
        </Modal>
        <Header>
          <h1>User Details</h1>
        </Header>
        <Container>{isLoading ? <UserSkeleton /> : detailsView}</Container>
      </SectionWrapper>
    </Wrapper>
  );
};

export default Userdetails;
